import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { Dialog, DialogContent, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";
import { GenericTable } from "../../atomic/organisms/GenericTable";
import moment from "moment";



const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "80%",
    },
    header: {
        background: '#68389F',
        color: 'white'
    },
    formControl: {
        marginTop: 15,
        minWidth: 120,
        // marginLeft: 20,
        // margin: theme.spacing(1),
    },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));


export const ModalPacientesEnSala = (props) => {

    const { open, setOpen, title } = props;
    const classes = useStyles();
    const { pacienteSala = [] } = useSelector((state) => state.agenda);
    const { pacientesEnEspera = [] } = useSelector((state) => state.agenda);
    const componentRef = useRef();




    const closeModal = () => {
        setOpen(false);
    }

    console.log(pacientesEnEspera)
    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <DialogContent>
                <Typography variant="h6" >
                    Cantidad de Turnos: {pacienteSala[0]?.cantidadTurnos}
                </Typography>
                <Typography variant="h6" >
                    Anunciados: {pacienteSala[0]?.confirmados}
                </Typography>
                <Typography variant="h6" >
                    Atendidos: {pacienteSala[0]?.atendidos}
                </Typography>
                <Typography variant="h6" >
                    En espera: {pacienteSala[0]?.enEspera}
                </Typography>
                <Grid xs={12}>

                </Grid>
                <Typography variant="h6" align="center" >
                    Listado de Pacientes en espera
                </Typography>
                <Grid xs={12}>
                    <GenericTable
                        ref={componentRef}
                        align="center"
                        data={pacientesEnEspera}
                        columns={[
                            {
                                label: "Carnet",
                                id: "carnet",
                                sort: true
                            },
                            {
                                label: "Apellido y Nombre",
                                id: "apeNom",
                                sort: true
                            },
                            {
                                label: "Fecha",
                                customBody: (item) => moment(item?.fecha).format("DD/MM/YYYY")
                            },
                            {
                                label: "Hora",
                                id: "hora"
                            },
                            {
                                label: "Hora Confirmado",
                                customBody: (item) => moment(item?.horaConfirmado).format("HH:mm")
                            },
                        ]}
                    />

                </Grid>
            </DialogContent>
        </Dialog>
    )
}
